module.exports = __webpack_public_path__ + "media/images/ui__arrowRightInactive-63ed87ea64a912fe6df641c9ad3e65fe.png";